<p>You are currently signed out!</p>

<button (click)="triggerAuthentication()">Authenticate again</button>